import { axios, base } from '../http';

/** 材料时段列表 */
export const getClassAffairWindows = (params) =>
  axios.get(`${base}/api/ClassAffairConfig/GetWindows`, { params });

/** 保存材料时段 */
export const saveClassAffairWindow = (data) =>
  axios.post(`${base}/api/ClassAffairConfig/SaveWindow`, data);

/** 删除材料时段 */
export const deleteClassAffairWindow = (data) =>
  axios.post(`${base}/api/ClassAffairConfig/DeleteWindow`, data);

/** 校区加分项配置 */
export const getClassAffairItemConfigs = (params) =>
  axios.get(`${base}/api/ClassAffairConfig/GetItemConfigs`, { params });

/** 保存校区加分项 */
export const saveClassAffairItemConfig = (data) =>
  axios.post(`${base}/api/ClassAffairConfig/SaveItemConfig`, data);

/** 加分项树 */
export const getClassAffairAdditionItemTree = (params) =>
  axios.get(`${base}/api/ClassAffairConfig/GetAdditionItemTree`, { params });

/** 台账时段 */
export const getClassAffairLedgerWindows = (params) =>
  axios.get(`${base}/api/ClassAffairConfig/GetLedgerWindows`, { params });

/** 学期选项 */
export const getClassAffairSemesterOptions = (params) =>
  axios.get(`${base}/api/ClassAffairConfig/GetSemesterOptions`, { params });

/** 保存台账时段 */
export const saveClassAffairLedgerWindow = (data) =>
  axios.post(`${base}/api/ClassAffairConfig/SaveLedgerWindow`, data);

/** 删除台账时段 */
export const deleteClassAffairLedgerWindow = (data) =>
  axios.post(`${base}/api/ClassAffairConfig/DeleteLedgerWindow`, data);

/** 材料提交分页 */
export const getClassAffairRecords = (params) =>
  axios.get(`${base}/api/ClassAffair/GetRecords`, { params });

/** 完成汇总 */
export const getClassAffairCompletionSummary = (params) =>
  axios.get(`${base}/api/ClassAffair/GetCompletionSummary`, { params });

/** 已交台账分页 */
export const getClassAffairLedgers = (params) =>
  axios.get(`${base}/api/ClassAffair/GetLedgers`, { params });

/** 已交台账明细 */
export const getClassAffairLedgerDetail = (params) =>
  axios.get(`${base}/api/ClassAffair/GetLedgerDetail`, { params });

/** 导出材料提交记录 */
export const exportClassAffairRecords = (params) =>
  axios.get(`${base}/api/ClassAffair/ExportRecords`, { params, responseType: 'blob' });

/** 导出完成汇总 */
export const exportClassAffairCompletionSummary = (params) =>
  axios.get(`${base}/api/ClassAffair/ExportCompletionSummary`, { params, responseType: 'blob' });

/** 导出已交台账 */
export const exportClassAffairLedgers = (params) =>
  axios.get(`${base}/api/ClassAffair/ExportLedgers`, { params, responseType: 'blob' });

/** 管理员作废台账（冲正赋分并解锁重交） */
export const voidClassAffairLedger = (data) =>
  axios.post(`${base}/api/ClassAffair/VoidLedger`, data);
